/**
 * «بعداً» و «نه» — روی همین مرورگر.
 *
 * ⚠ در `localStorage` می‌ماند و نه در `core/lib/prefs`: آن یکی ترجیح‌های
 * مشترکِ هر دو اپ است، و «اجازه‌ی اعلانِ این مرورگر» چیزی است که فقط
 * این‌جا معنی دارد — روی گوشیِ همان آدم بی‌معنی است. و ⚠ همین یعنی
 * انتخابش با دستگاه است نه با حساب، که درست هم همین است: کاربر دارد
 * درباره‌ی **این مرورگر** تصمیم می‌گیرد.
 */
import { SNOOZE_MS } from '@/core/lib/webPushOffer';

const KEY = 'whosup.pushSnooze';

/** `null` یعنی هرگز نپرسیده‌ایم، `Infinity` یعنی گفت «نه». */
export function readSnooze(): number | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    if (raw === 'never') return Infinity;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    // حالتِ ناشناسِ بعضی مرورگرها حتی خواندن را هم پرت می‌کند. نبودنِ
    // ترجیح یعنی «نپرسیده‌ایم» — بدترین حالتش یک کارتِ اضافه است.
    return null;
  }
}

const write = (value: string): void => {
  try { localStorage.setItem(KEY, value); } catch { /* همان بالا */ }
};

export function snoozeOneWeek(): number {
  const until = Date.now() + SNOOZE_MS;
  write(String(until));
  return until;
}

export function snoozeForever(): number {
  write('never');
  return Infinity;
}
